import React from 'react'
import { useAppSelector } from 'src/app/hooks'
import { CustomCard, CustomTable } from 'src/components'
import { integrationPurchasesSelector } from 'src/features'
import { integrationPurchaseListColumns } from 'src/core/table-columns'
import IntegrationTransactionListHeader from './IntegrationTransactionListHeader/IntegrationTransactionListHeader'

const IntegrationTransactionList: React.FC = () => {
  const { loading, filtered } = useAppSelector(integrationPurchasesSelector)

  return <CustomCard loading={loading}>
    <IntegrationTransactionListHeader quantity={filtered.length} />
    <CustomTable
      columns={integrationPurchaseListColumns}
      dataSource={filtered}
    />
  </CustomCard>
}

export default IntegrationTransactionList
